
































































































































































































































































































































































































































import Vue from 'vue';
import axios from 'axios';
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.snow.css';

Vue.use(VueQuillEditor);

export default Vue.extend({
  name: 'TrainingDetail',
  data: () => ({
    editorOption: {
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', { header: 1 }, { header: 2 }, { size: ['small', false, 'large', 'huge'] }],
          [{ color: [] }, { background: [] }, { list: 'bullet' }, 'image'],
        ],
      },
    },
    chosenSlides: [],
    currentSlide: '',
    uploadStep: 0,
    uploadLoader: false,
    languages: [],
    places: [{}],
    trainings: [{ ID: 0, name: 'Žádné', nextTraining: 0 }],
    training: {
      ID: 0,
      name: '',
      language: '',
      displayName: '',
      questionsCount: 0,
      questionsRand: false,
      slidesMinTime: 30,
      questionsMaxTime: 3600,
      points: 0,
      enabled: false,
      public: false,
      signature: false,
      protocol: true,
      allowSkipSlides: false,
      validityDays: 365,
      nextTraining: 0,
      slides: [
        {
          uuid: '',
          name: '',
          enabled: false,
        },
      ],
      IDPlaces: [],
      questions: [{}],
    },
    modalDelete: false,
    modalDeleteTitle: '',
    modalDeleteText: '',
    modalDeleteReferences: [{}], // Ak je skolenie referencovane ako navazujici nesmie byt zmazane
    modalSlide: false,
    saveSnack: false,
    saveMsg: '',
    validForm: false,
    rules: {
      required: (value: string) => !!value || 'Pole je povinné',
      requiredArray: (value: []) => value.length > 0 || 'Pole je povinné',
      number: (value: string) => {
        const pattern = /^\d+$/;
        return pattern.test(value) || 'Hodnota musí být číslo!!!';
      },
    },
  }),
  watch: {
    '$store.state.currentTraining.ID'() {
      this.trainingsLoad();
      this.training.slides = [];
      this.currentSlide = '';
      this.dataLoad();
    },
  },
  mounted() {
    this.trainingsLoad();
    this.languagesLoad();
    this.placesLoad();
  },
  computed: {
    maxTimeComputed: {
      get: function () {
        return this.training.questionsMaxTime / 60;
      },
      set: function (newValue: number) {
        this.training.questionsMaxTime = newValue * 60;
      },
    },
  },
  methods: {
    dataLoad() {
      this.chosenSlides = [];
      if (this.$store.state.currentTraining.ID != undefined) {
        axios
          .get(`/api/v1/training/${this.$store.state.currentTraining.ID}`)
          .then((response) => {
            this.training = response.data;
          })
          .catch((err) => {
            this.$store.dispatch('catchErrHandler', err);
          });
      }
    },
    dataSave() {
      if ((this.$refs.trainingDetailForm as Vue & { validate: () => boolean }).validate() !== true) {
        this.$store.commit('globalMessage', 'Formulář obsahuje chyby!!!');
      } else {
        axios
          .put(`/api/v1/training/${this.$store.state.currentTraining.ID}`, this.training)
          .then((response) => {
            if (response.data.status === 'success') {
              this.saveMsg = 'Úspěšně uloženo';
              this.$store.commit('trainingUpdate', this.$store.state.currentTraining.ID);
              this.saveSnack = true;
            }
          })
          .catch((err) => {
            this.$store.dispatch('catchErrHandler', err);
          });
      }
    },
    dataDeleteInit() {
      this.modalDeleteReferences = [];
      for (const training of this.trainings) {
        if (training.nextTraining === this.training.ID) {
          this.modalDeleteReferences.push(training);
        }
      }
      console.log('ref: ', this.modalDeleteReferences);
      if (this.modalDeleteReferences.length > 0) {
        this.modalDeleteTitle = 'Školení není možné smazat';
        this.modalDeleteText =
          'Toto školení je označeno jako "Navazující školení". Pokud chcete školení smazat je nutno zrušit označení v následujících školeních: ';
      } else {
        this.modalDeleteTitle = 'Smazat školení?';
        this.modalDeleteText = 'Skutečne chcete smazat školení?';
      }
      this.modalDelete = true;
    },
    dataDelete() {
      axios
        .delete(`/api/v1/training/${this.$store.state.currentTraining.ID}`)
        .then(() => {
          this.$store.commit('trainingUpdate', -1);
          this.modalDelete = false;
        })
        .catch((err) => {
          this.modalDelete = false;
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    languagesLoad() {
      axios
        .get('/api/v1/language')
        .then((response) => {
          this.languages = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    placesLoad() {
      axios
        .get('/api/v1/place')
        .then((response) => {
          this.places = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    trainingsLoad() {
      axios
        .get('/api/v1/training')
        .then((response) => {
          this.trainings = [{ ID: 0 as number, name: 'Žádné' as string }, ...response.data];
          this.trainings.splice(
            this.trainings
              .map((item): number => {
                return item.ID;
              })
              .indexOf(this.$store.state.currentTraining.ID),
            1,
          );
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    arrayMoveUp(array: {}[], indexArray: number) {
      array.splice(indexArray, 0, array.splice(indexArray - 1, 1)[0]);
      return array;
    },
    arrayMoveDown(array: {}[], indexArray: number) {
      array.splice(indexArray, 0, array.splice(indexArray + 1, 1)[0]);
      return array;
    },
    questionAdd() {
      this.training.questions.push({ answers: [], question: '' });
    },
    questionDelete(questions: [], indexQuestion: number) {
      if (confirm('Skutečně samzat?')) {
        questions.splice(indexQuestion, 1);
        return questions;
      }
    },
    answerAdd(question: { answers: {}[] }, indexQuestion: number) {
      question.answers.push({
        text: (((this.$refs['newAnswer-' + indexQuestion] as {}[])[0] as {}) as { lazyValue: string }).lazyValue as string,
        points: (((this.$refs['newPoints-' + indexQuestion] as {}[])[0] as {}) as { lazyValue: number }).lazyValue as number,
      });
      (((this.$refs['newAnswer-' + indexQuestion] as {}[])[0] as {}) as { lazyValue: string }).lazyValue = '';
      (((this.$refs['newPoints-' + indexQuestion] as {}[])[0] as {}) as { lazyValue: number }).lazyValue = 0;
      return question;
    },
    answerDelete(question: { answers: {}[] }, indexAnswer: number) {
      if (confirm('Skutečně samzat?')) {
        question.answers.splice(indexAnswer, 1);
        return question;
      }
    },
    slideEnlarge() {
      console.log('zvetsit');
    },
    slideDropFile(inputSlides: { dataTransfer: { files: [] } }) {
      //this.file = e.dataTransfer.files[0];
      this.chosenSlides = Array.from(inputSlides.dataTransfer.files);
    },
    slideDelete(slides: [], indexSlide: number) {
      if (confirm('Skutečně samzat?')) {
        slides.splice(indexSlide, 1);
        return slides;
      }
    },
    slidesUpload() {
      this.uploadLoader = true;
      const requests = this.chosenSlides.reduce((promiseChain, item) => {
        return promiseChain.then(
          () =>
            new Promise((resolve) => {
              const formData = new FormData();
              formData.append('file', item);
              axios
                .post(`/api/v1/training/${this.$store.state.currentTraining.ID}/slide`, formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data',
                  },
                })
                .then((response) => {
                  this.training.slides.push({ uuid: response.data.uuid, name: '', enabled: true });
                  this.uploadStep++; // Ak sa pokracuje na dalsi upload tak nastav true
                  resolve();
                })
                .catch((err) => {
                  this.uploadStep = 0; // Info pre Watcher zmena stavu
                  this.$store.dispatch('catchErrHandler', err);
                });
            }),
        );
      }, Promise.resolve());
      requests.then(() => {
        this.chosenSlides = [];
        this.uploadLoader = false;
      });
    },
  },
});
